import basicAppConfig from "../../infra/constants/basicAppConfig";
import ClientStorage from "./ClientStorage";
const CLIENT_STORAGE_VERSION = "1";
const clientStorage = new ClientStorage({
    applicationId: basicAppConfig.applicationId,
    version: CLIENT_STORAGE_VERSION,
});
void clientStorage.verifyStoredVersion().catch(clientStorage.defaultCatch);
export default clientStorage;
